module.exports = "<uib-accordion close-others=\"$ctrl.closeOthers\">\n    <div uib-accordion-group class=\"panel-default\" heading=\"{{section.title}}\" ng-repeat=\"section in $ctrl.sections\">\n        <div ng-bind-html=\"section.content\"></div>\n    </div>\n</uib-accordion>"


//////////////////
// WEBPACK FOOTER
// ./client/components/accordion-widget/accordion-widget.component.html
// module id = 589
// module chunks = 0